module.exports = __webpack_public_path__ + "static/media/26_plantilla_navidad_menu_4_y_8_rec_cinta_motivo_1.31908904.png";